<template>

  <popup
    buttonStyle="primary"
    :heading="permitLabel + ' Application'"
    size="default"
    :showText="showText"
    :buttonText="permitLabel"
    :buttonSize="size"
    buttonIcon="fa fa-file-alt"
    :disableButton="!isManager('admin|finance|management|property')"
    @save="onSaveDialog"
    @close="onCloseDialog">

      <progress-workflow ref="Progress" :row-data="rowData" />

  </popup>

</template>


<script>

import {settings} from '@/components/Data'

import ProgressWorkflow from '@/components/progress/ProgressWorkflow'

export default {
  components: {
    ProgressWorkflow
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    showText: {
      type: Boolean,
      default: true
    },

    size: {
      type: String,
      default: 'small'
    }
  },

  methods: {
    resetData () {
      this.$refs.permits.reset()
    },

    onSaveDialog () {
      this.$refs.permits.save()
    },

    onCloseDialog () {
      this.$refs.permits.close()
    }
  },

  data () {
    return {
      permitLabel: settings.permitLabel
    }
  }
}

</script>
